import { Modal } from 'src/modules/common/components/Modal/Modal.tsx';
import { ModalHeader } from 'src/modules/common/components/Modal/ModalHeader.tsx';
import { I18n } from 'src/modules/common/components/I18n/I18n.tsx';
import { MESSAGES } from 'src/modules/common/constants';
import { ModalBody } from 'src/modules/common/components/Modal/ModalBody.tsx';
import { Selection } from 'src/projects/types/Selection';
import { ChangeEvent, useCallback, useState } from 'react';
import { ModalFooter } from 'src/modules/common/components/Modal/ModalFooter.tsx';
import { Button } from 'src/common/Button/Button.tsx';
import { InlineNotification } from 'src/modules/common/components/InlineNotification/InlineNotification.tsx';

type Props = {
    selection: Selection;
    opened: boolean;
    handleClose: () => void;
    onSave: (value: string) => void;
    isNameValid: (Selection: Selection, name: string) => boolean;
}

export const RenameProjectModal = ({ selection, opened, handleClose, onSave, isNameValid }: Props) => {
    const [value, setValue] = useState(selection.name);
    const [nameValid, setNameValid] = useState(true);
    const onChange = useCallback((event: ChangeEvent<HTMLInputElement>) => {
        setNameValid(isNameValid(selection, event.target.value));
        setValue(event.target.value);
    }, [selection, isNameValid, setNameValid, setValue]);
    return (
        <Modal opened={opened} handleClose={handleClose}>
            <ModalHeader handleClose={handleClose} title={MESSAGES.projectPageRenameModalHeader}/>
            <ModalBody>
                <div className="vss-text-input-wrapper">
                    <label
                        className="vss-text-input__label"
                        htmlFor="name"
                    ><I18n messageId={MESSAGES.projectPageRenameLabel}/>
                    </label>
                    <div className="vss-text-input">
                        <input
                            id="name"
                            name="name"
                            type="text"
                            value={value}
                            onChange={onChange}
                            maxLength={100}
                        />
                    </div>
                </div>
                {!nameValid && <InlineNotification message={MESSAGES.projectPageSelectionNameIsNotUniq} type="error"/>}
            </ModalBody>
            <ModalFooter>
                <Button
                    kind="secondary"
                    fullWidth={true}
                    onClick={handleClose}
                >
                    <I18n messageId={MESSAGES.CANCEL}/>
                </Button>

                <Button
                    fullWidth={true}
                    onClick={() => {
                        if (value !== selection.name) {
                            onSave(value);
                        } else {
                            handleClose();
                        }
                    }}
                    disabled={!nameValid}
                >
                    <I18n messageId={MESSAGES.apply}/>
                </Button>
            </ModalFooter>
        </Modal>
    );
};
